<div
  class="transcript-scroll flex flex-col h-full min-h-0 overflow-y-auto"
  [appScrollToBottom]="utterances.length">
  @if (deleted) {
    <div class="flex flex-1 flex-col items-center justify-center px-4 text-center"
      data-testid="transcript-deleted">
      <p class="body-medium !font-normal m-0"
        [ngClass]="variant === 'dark' ? 'text-inverse-on-surface' : 'text-on-surface-variant'">
        {{ 'Transcript no longer available' | translate }}
      </p>
      <p class="body-medium !font-normal m-0 mt-1"
        [ngClass]="variant === 'dark' ? 'text-inverse-on-surface opacity-50' : 'text-outline'">
        {{ "This transcript was removed under your organisation's data retention policy" | translate }}
      </p>
    </div>
  } @else if (utterances.length === 0) {
    <p class="body-medium flex-1 flex items-center justify-center px-4 text-center"
      [ngClass]="variant === 'dark' ? 'text-inverse-on-surface opacity-50' : 'text-on-surface-variant'">
      {{ 'No transcript yet.' | translate }}
    </p>
  } @else {
    <div class="flex flex-col gap-4 px-4">
      @for (utterance of utterances; track $index) {
        <div class="flex gap-4 items-baseline w-full">
          <p class="transcript-time shrink-0 w-16 max-w-16"
            [ngClass]="variant === 'dark' ? 'text-white' : 'text-outline'">
            {{ formatTime(utterance.offset) }}
          </p>
          <p class="body-medium !font-normal flex-1 min-w-0 break-words"
            [ngClass]="variant === 'dark' ? 'text-on-primary' : 'text-on-surface-variant'">
            {{ utterance.text }}
            @if (utterance.final === false) {
              <span class="transcript-progress" aria-hidden="true" data-testid="transcript-progress">
                <span>.</span><span>.</span><span>.</span>
              </span>
            }
          </p>
        </div>
      }
    </div>
  }
</div>
